import React from "react";

import Event from "./Event";

function EventDetail(props) {
  return <Event {...props} />;
}

export default EventDetail;